import { CKEditor } from "@ckeditor/ckeditor5-react";
// Import ClassicEditor through wrapper that handles UMD module
import Editor from '../lib/ckeditor-wrapper';

const CkEditorUI = (props) => {
    return <CKEditor
        data={props.data}
        editor={Editor}
        config={props.editorConfiguration}
        onChange={(event, editor) => {
            let data = editor.getData();
            props.handleEditorChange(data);
        }}
    />
}
export default CkEditorUI;